import { Injectable, OnDestroy } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { ILicense } from '../models/license/license.model';
import { Subscription, lastValueFrom } from 'rxjs';


/*
This Service holds the application wide configurations
including the endpoints to the services
the license settings can be changed in the application
todo: find a better solution

*/

@Injectable()
export class AppConfigService implements OnDestroy
{
    private subscriptions : Subscription[] = [];
    public static appConfig: any;
    public static licenses: ILicense;


    constructor( private http: HttpClient) {}

    // called from withing app.module to initialize the application.
    public loadAppConfig()
    {
        return lastValueFrom(this.http.get('./assets/data/appConfig.json'))
            .then(data =>
            {
                AppConfigService.appConfig = data;
                if(AppConfigService.appConfig.WebAPIServer.slice(-1) == "/")
                {
                    AppConfigService.appConfig.WebAPIServer = AppConfigService.appConfig.WebAPIServer.slice(0,AppConfigService.appConfig.WebAPIServer.length -1);
                }
                this.subscriptions.push(this.http.get<ILicense>(AppConfigService.appConfig.WebAPIServer + "/api/license/get").subscribe(
                    license =>
                    {
                        AppConfigService.licenses = license;
                    }));
            });
    }



    public formatLocalDate(str: string, inputDate: Date): string
    {
        if ((str.indexOf("{{DateWithTime}}")) !== -1)
        { //date with time place holder

            let dateWithTime = new Date(inputDate);
            let time = dateWithTime.toLocaleTimeString().substring(0, 5);
            let date = dateWithTime.toLocaleDateString(AppConfigService.appConfig.CurrentLanguage, AppConfigService.appConfig.StandardDateFormat);
            str = str.replace("{{DateWithTime}}", date + " " + time + " Uhr");
            return str;

        } 
        else if (str.indexOf("{{Date}}") !== -1)
        { // date placeholder

            let dateWithTime = new Date(inputDate);
            let date = dateWithTime.toLocaleDateString(AppConfigService.appConfig.CurrentLanguage, AppConfigService.appConfig.StandardDateFormat);
            str = str.replace("{{Date}}", date);
            return str;
        } 
        else
        {
            return (str);
        }
    }

    ngOnDestroy()
    {
        this.subscriptions.forEach(s => s.unsubscribe() );
    }
}